export default __webpack_public_path__ + "static/media/gallery-wip-emitter-tip_00.ff40740e.jpg";